export default __webpack_public_path__ + "static/media/sanmar17.41e16ff1.jpg";